import { Box, Divider } from '@mui/material';
import { PhotoEdit } from '../components';
import type { PhotoData } from '../types';

interface PhotosSectionProps {
  photoList: PhotoData[];
  loading: boolean;
  siteId: number;
  deleteImage: (photoId: number) => Promise<void>;
  onPhotosChanged: (updatedPhotoList: PhotoData[]) => void;
}

export const PhotosSection: React.FC<PhotosSectionProps> = ({
  photoList,
  loading,
  siteId,
  deleteImage,
  onPhotosChanged,
}) => {
  return (
    <>
      <Divider sx={{ mt: '1.125rem' }} />
      {/* Photos Section */}
      <Box sx={{ position: 'relative' }}>
        <PhotoEdit
          photoList={photoList}
          deletePhoto={deleteImage}
          onPhotosChanged={onPhotosChanged}
          siteId={siteId}
          isLoadingPhoto={loading}
        />
      </Box>

      {/* Footer */}
      <Box sx={{ height: '6.25rem' }} />
    </>
  );
};
